import 'react-app-polyfill/stable'
import 'core-js'
// import 'localstorage-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store, persistor } from './store/index'
import { PersistGate } from 'redux-persist/integration/react'
import history from './module/history'
import { registerPlugin } from 'react-filepond'

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileEncode from 'filepond-plugin-file-encode'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import SocketProvider from './containers/SocketProvider'
// import OnlineProvider from './containers/OnlineProvider'

import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { ErrorBoundary } from 'react-error-boundary';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import PageError from './components/PageError'
import ProcessProvider from 'src/components/ProgressPanel/index'
import { NotificationProvider } from './context/NotificationContext'




const charAT = `

 █████╗ ██╗██████╗  █████╗ ███╗   ██╗    ██████╗ ███████╗██╗   ██╗
██╔══██╗██║██╔══██╗██╔══██╗████╗  ██║    ██╔══██╗██╔════╝██║   ██║
███████║██║██║  ██║███████║██╔██╗ ██║    ██║  ██║█████╗  ██║   ██║
██╔══██║██║██║  ██║██╔══██║██║╚██╗██║    ██║  ██║██╔══╝  ╚██╗ ██╔╝
██║  ██║██║██████╔╝██║  ██║██║ ╚████║    ██████╔╝███████╗ ╚████╔╝ 
╚═╝  ╚═╝╚═╝╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═══╝    ╚═════╝ ╚══════╝  ╚═══╝  
 `;
console.info(`%c${charAT}`, 'color: #5BE49B');

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileEncode,
  FilePondPluginFileValidateType,
)

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}



ReactDOM.render(

  <Provider store={store}>
    <PersistGate loading={loading} persistor={persistor}>
      <NotificationProvider>
        <SocketProvider>
          <ProcessProvider>
            <ErrorBoundary FallbackComponent={PageError}>
              <App history={history} />
            </ErrorBoundary>
          </ProcessProvider>
        </SocketProvider>
      </NotificationProvider>
    </PersistGate>
  </Provider>
  ,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// if (process.env.NODE_ENV === 'production') {
//   serviceWorkerRegistration.register();
// }
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.unregister();
}

if (process.env?.NODE_ENV === "development")
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('FCM Service Worker registered:', registration);
      })
      .catch((err) => {
        console.error('FCM Service Worker registration failed:', err);
      });
  }



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
reportWebVitals()